import { alpha } from '@mui/material'
import { getPaletteValue } from './MuiChip'
import type { OmuiChipWithActionButtonComponent } from '../../../ChipWithActionButton'

export const OmuiChipWithActionButton: OmuiChipWithActionButtonComponent = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      display: 'inline-flex',
      alignItems: 'center',
      minWidth: 0,
      borderRadius: '6px',
      border: `1px solid ${alpha(theme.palette.text.primary, 0.26)}`,
      overflow: 'hidden',
      backgroundColor: getPaletteValue(theme, ownerState?.color, 'light'),
      ...(ownerState?.clickable && {
        cursor: 'pointer',
        '&:hover, &:focus-within': { backgroundColor: alpha(theme.palette.text.primary, 0.08) },
      }),
    }),
    chip: {
      border: 'none',
      borderRadius: '6px 0 0 6px',
      backgroundColor: 'transparent',
      flex: '1 1 auto',
      minWidth: 0,
      '& .MuiChip-icon': { marginLeft: '8px' },
      '& .MuiChip-label': { paddingRight: '6px' },
      '&.MuiChip-clickable:hover, &.MuiChip-clickable:focus-visible': { backgroundColor: 'transparent' },
    },
    actionButtonSlot: ({ theme }) => ({
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
      paddingRight: theme.spacing(0.5),
      // No separate hover circle — the whole pill shares one hover state via the root.
      '& .MuiIconButton-root': { padding: '2px', '&:hover': { backgroundColor: 'transparent' } },
    }),
  },
}
